import settings from '@shared/settings'
import { saveUserSession } from '@shared/utils/sessionHandover'
import Auth from '@aws-amplify/auth'

export const authenticatedGuard = async (to, from, next) => {
    if (!await isAuthenticated()) {
        next({ name: 'home' })
    } else {
        next()
    }
}

export const isAuthenticated = async () => {
    try {
        await Auth.currentSession()
        return true
    } catch (e) {
        console.log(`No session: ${e}`)
        return false
    }
}

export const exitFromAppGuard = async (to, from, next) => {
    if (settings.featureFlags.isDeepLinkingEnabled() && settings.isAppToBrowserRedirectEnabled() && 'w' in to.query) {
        const token = await saveUserSession()
        // this will force mobile device to open this path in browser, users will leave the app
        const params = new URLSearchParams({ ...to.query, w: new Date().getTime().toString(), ...token })
        window.location = `${to.path}?${params}`
        next(false)
    } else {
        next()
    }
}

export const isFastCheckoutEnabledGuard = async (to, from, next) => {
    if (!settings.featureFlags.isFastCheckoutEnabledGuard()) {
        next({ name: 'home' })
    } else if (!await isAuthenticated()) {
        next({ name: 'scan-failed' })
    } else {
        next()
    }
}
